import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GLOBALSETTINGS } from '../data/constants';

interface SuggestedFolderSelectedState {
    folderId: number | null;
    parentFolderId: number | null;
}

const initialState: SuggestedFolderSelectedState = {
    folderId: GLOBALSETTINGS.DEFAULT_STATE,
    parentFolderId: GLOBALSETTINGS.DEFAULT_STATE
};

const suggestedFolderSelectedSlice = createSlice({
    name: 'suggestedFolderSelected',
    initialState,
    reducers: {
        setSuggestedFolderSelected: (state, action: PayloadAction<{ folderId: number | null, parentFolderId: number | null }>) => {
            state.folderId = action.payload.folderId;
            state.parentFolderId = action.payload.parentFolderId;
        },
        clearSuggestedFolderSelected: (state) => {
            state.folderId = GLOBALSETTINGS.DEFAULT_STATE;
            state.parentFolderId = GLOBALSETTINGS.DEFAULT_STATE;
        }
    },
});

export const { setSuggestedFolderSelected, clearSuggestedFolderSelected } = suggestedFolderSelectedSlice.actions;

export default suggestedFolderSelectedSlice.reducer;
